import { RootState } from "../models";

export const selectSessionId = (state: RootState) => {
  const sessionId = state.data.isLoaded ? state.data.sessionId : "";
  return sessionId;
};
